import React, { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";

const links = [
  ["home", "Home"],
  ["about", "About"],
  ["skills", "Skills"],
  ["cyber-range", "Cyber Range"],
  ["projects", "Projects"],
  ["experience", "Experience"],
  ["contact", "Contact"]
];

function NavigationBar() {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (sectionId) => {
    setExpanded(false);
    const hash = `#${sectionId}`;

    if (location.pathname === "/") {
      navigate({ pathname: "/", hash });
      window.setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 30);
      return;
    }

    navigate({ pathname: "/", hash });
  };

  return (
    <Navbar expanded={expanded} fixed="top" expand="lg" className="sticky portfolio-navbar">
      <Container>
        <Navbar.Brand onClick={() => goToSection("home")} className="logo" role="button">
          stonyango
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="portfolio-navigation"
          aria-label="Toggle navigation"
          onClick={() => setExpanded((current) => !current)}
          className="custom-toggler"
        />

        <Navbar.Collapse id="portfolio-navigation">
          <Nav className="ms-auto">
            {links.map(([id, label]) => (
              <Nav.Link key={id} onClick={() => goToSection(id)}>
                {label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
